'use strict';

angular.module('cgmemApp')
	.controller('EditMemberCtrl',
		function ($rootScope, $scope, $q, $state, $stateParams, $log, $filter, AppConfig, WorkingAccount, Member, User) {

			$scope.dobPrivate = false;
			var mailingLists = [];
			var memberGroups = [];

			var member;

			$q.all([AppConfig.get(), WorkingAccount.get(), User.get()])
				.then(function (d) {

					mailingLists = d[0].mailingLists;
					memberGroups = d[0].memberGroups;
					var aggregate = d[1];
					var user = d[2];

					$scope.isInGroup = User.isInGroup;

					if ($stateParams.memberId && _.find(aggregate.members, { _id: $stateParams.memberId })) {
						member = _.find(aggregate.members, { _id: $stateParams.memberId });
						var originalMember = angular.copy(member);
					} else {
						member = new Member;
						member.accountId = aggregate.account._id;
						member.adult = true;
						member.senior = false;
						member.gender = 'M';
						member.emailLists = ['club'];
						member.groups = [];
						member.canLogin = true;
						member.ageBand = 'adult'
					}

					$scope.member = member;
					//$scope.member.password = "";

					if ($scope.member._id && !$scope.member.dob)
						$scope.dobPrivate = true;

					if ($scope.member.dob)
						$scope.dobString = $filter('date')($scope.member.dob, 'MM/dd/yyyy');

					// build an object for the mailingLists
					$scope.mailingLists = angular.copy(mailingLists);
					_.forEach($scope.mailingLists, function (m) {
						m.value = (member.emailLists.indexOf(m.code) >= 0);
					});
					// build an object for the userGroups
					$scope.memberGroups = angular.copy(memberGroups);
					_.forEach($scope.memberGroups, function (m) {
						m.value = (member.groups.indexOf(m.code) >= 0);
					});

					$scope.dobPrivateToggle = function () {
						if ($scope.dobPrivate) {
							$scope.member.ageBand = 'adult';
							$scope.member.dob = '';
						}
					}

					$scope.ok = function () {
						// First, can we do this
						if (user._id == member._id) {
							if (member.deleted || !member.email || !member.canLogin) {
								$rootScope.$emit('generalAlert', 'You cannot delete / disable yourself!  If this is what you really want, contact us at info@countryglen.org.');
								if (originalMember) {
									angular.copy(originalMember, member);
								}
								return;
							}

						}

						if ($scope.dobPrivate)
							$scope.member.dob = '';
						else {
							$scope.member.ageBand = '';
							$scope.member.dob = new Date($scope.dobString);
						}

						$scope.member.emailLists = [];
						_.forEach($scope.mailingLists, function (m) {
							if (m.value) $scope.member.emailLists.push(m.code);
						});
						$scope.member.groups = [];
						_.forEach($scope.memberGroups, function (m) {
							if (m.value) $scope.member.groups.push(m.code);
						});

						($scope.member._id
							? $scope.member.$update({ memberId: $stateParams.memberId })
							: $scope.member.$save().then(d => WorkingAccount.pushMember(d))
						)
							.catch(err => $rootScope.$emit('generalAlert', 'Error updating or saving member: ' + err.data.message))
							.finally($state.go('authenticated.profile'));
					};

					$scope.cancel = function () {
						if (originalMember) {
							angular.copy(originalMember, member);
						}
						$state.go("authenticated.profile");
					};

					$scope.delete = function () {
						$scope.member.deleted = true;
						$scope.ok();
					}
				}, function (err) {
					$rootScope.$emit('generalAlert', 'Could not load this member due to internal error.  Please try later.');
				});
		});		// FIX should deal with failure here.

